import { render } from "./ComplaintDetails.vue?vue&type=template&id=08de9448"
import script from "./ComplaintDetails.vue?vue&type=script&lang=js"
export * from "./ComplaintDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__